import { useMutation, gql } from '@apollo/client';

export const DELETE_REVIEW_DOCUMENT = gql`
  mutation useDeleteReviewDocument($input: DeleteReviewDocumentInput!) {
    deleteReviewDocument(input: $input) {
        id
    }
  }
`;

export default (options) => {
  return (
    useMutation(DELETE_REVIEW_DOCUMENT, options)
  );
}
